import React from 'react'
import './SummaryProductBudgetMobile.scss'
import { firstCharCapitalize } from '../utils/utils'
import CantidadComponent from '../components/CantidadComponent'
import { EquisIcons } from '../utils/icons'

export const SummaryProductBudgetDesktop = (props) => {
    const { productBudget, numberInit, total, clickChange, clickDelete } = props
    return (
        <div className="summary-product-budget-desktop-container">
            <div className="img">
                <img src={"/static/imgProducts/tn_" + productBudget.product.Fotografia + "_p.jpg"} onError={(e) => {
                    e.target.onerror = null
                    e.target.src = '/static/img/no-imagen-fansa.png'
                }} alt="" />
            </div>
            <div className="data referencia">
                <p className="title">Referencia</p>
                <p className="data-info">{productBudget.product.RefSuelto}</p>
            </div>
            <div className="data producto">
                <p className="title">Producto</p>
                <p className="data-info">{firstCharCapitalize(productBudget.product.Descripcion)}</p>
            </div>
            <div className="data cantidad">
                <p className="title">Cantidad</p>
                <CantidadComponent numberInit={numberInit} formatSelected={productBudget.format} onClick={clickChange} />
            </div>
            <div className="data formato">
                <p className="title">Formato</p>
                {productBudget.format === 'UVenta2021Suelto' && productBudget.product.Descripcion.toLowerCase().indexOf('set/') > -1 && <p className="data-info">Set</p>}
                {productBudget.format === 'UVenta2021Suelto' && productBudget.product.Descripcion.toLowerCase().indexOf('set/') === -1 && <p className="data-info">Unidad</p>}
                {productBudget.format === 'UnidadesPack' && <p className="data-info">Pack</p>}
                {productBudget.format === 'UnidadesPallet' && <p className="data-info">Pallet</p>}
                {productBudget.format === 'expositor' && <p className="data-info">Expositor</p>}
            </div>
            <div className="data total">
                <p className="title">Total</p>
                <p className="data-info">{total}</p>
            </div>
            <div className="data pointer delete" onClick={() => clickDelete(productBudget)}>
                <div className="data-delete">
                    <EquisIcons size={12} />
                </div>
            </div>
        </div>
    )
}
